export default __webpack_public_path__ + "static/media/print_kouji_1.68cb5513.svg";